import React, { useState, useEffect, useContext } from "react";
import { APIContext } from "../../Contexts/APIContext";
import Grid from "@mui/material/Grid";
import getActiveFilterDateRangeFlag from "../../Utilities/DateRange";
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TeamLeaderQaiResponseContainer from "../TeamLeaderView/TeamLeaderQaiResponseContainer";
import QaiChallengeNote from "./QaiChallengeNote";
import GetChallengeNoteViewModel from "./ViewModels/GetChallengeNoteViewModel";
import { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";

interface IAgentQaiChallengeNotesProps {
    view: string
    question: QaiScorecardChallengeQuestionViewModel
    filters: QaiChallengeFilterViewModel
    getChallengeCount: () => void
    getChallengedQuestions: () => void
}

export default function AgentQaiChallengeNotes({ view, question, filters, getChallengeCount, getChallengedQuestions }: IAgentQaiChallengeNotesProps) {
    const { get } = useContext(APIContext);
    const [agentNotes, setAgentNotes] = useState<GetChallengeNoteViewModel[]>([]);
    const [selectedNote, setSelectedNote] = useState<GetChallengeNoteViewModel | null>(null);
    const [showRejected, setShowRejected] = useState(false);

    useEffect(() => {
        getChallenges();
    }, [])

    const getChallenges = () => {
        get('QaiScorecardChallenge',
            `GetChallenges?questionId=${question.questionId}&aiTemplateVersion=${question.aiTemplateVersion}&dateRangeFlag=${getActiveFilterDateRangeFlag(filters)}`,
            (data) => setAgentNotes(data))

        getChallengeCount();
    }

    const handleShowRejectedChange = () => {
        setShowRejected(!showRejected);
    }

    return (
        <Grid height='95%' size={12} border='solid 1px rgb(192, 192, 192)' borderRadius='4px' sx={{ backgroundColor: '#f5f5f5' }}>
            <Grid container size={12} justifyContent='flex-end'>
                <Grid>
                    <FormControlLabel
                        control={<Checkbox checked={showRejected} onChange={handleShowRejectedChange} />}
                        label='Show Rejected' />
                </Grid>
            </Grid>
            <Grid container padding={2} sx={{ overflowY: 'auto' }} maxHeight='94%'>
                {
                    agentNotes.map(x =>
                        (showRejected || x.state !== 'Rejected') &&
                        <>
                            <QaiChallengeNote view={view} note={x} setSelectedNote={setSelectedNote} />
                        </>
                    )
                }
            </Grid>
            {
                !!selectedNote &&
                <TeamLeaderQaiResponseContainer
                    view={view}
                    open={!!selectedNote}
                    challenge={selectedNote!}
                    setChallenge={setSelectedNote}
                    getChallenges={getChallenges}
                    getChallengedQuestions={getChallengedQuestions}
                />
            }
        </Grid >
    )
}